import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Card } from 'src/components/Card/Card';
import { Pagination } from 'src/components/Pagination';
import { StatusView } from 'src/components/StatusView/StatusView';
import { LoanApplicationDto } from 'src/generated-api-client';
import { LoanApplicationCommentForm } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationCommentForm';
import { LoanApplicationCommentsList } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationCommentsList';
import { LoanApplicationCommentsStore } from 'src/stores/LoanApplicationCommentsStore/LoanApplicationCommentsStore';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { Entity } from 'src/utils/mobx/BasicStore/BasicStore.types';
import styled from 'styled-components';

type LoanApplicationCommentsTabProps = {
    application?: LoanApplicationDto;
};

const store = LoanApplicationCommentsStore;

export const LoanApplicationCommentsTab = observer(
    ({ application }: LoanApplicationCommentsTabProps) => {
        useEffect(() => {
            if (application?.id) {
                store.filterCriteria.setFilter({ id: application.id });
                store.loadList();
            }

            return () => {
                store.filterCriteria.resetFilter();
                store.pager.reset();
                store.listLoader.reset();
                store.createItemLoader.reset();
            };
        }, [application?.id]);

        return (
            <>
                <LoanApplicationCommentForm applicationId={application?.id} />
                <Card
                    title={
                        <StyledCardTitle>
                            {t('LoanApplication.Comments.Title')}
                            <StatusView
                                status={String(store.pager.total)}
                                statusMap={[]}
                            />
                        </StyledCardTitle>
                    }
                >
                    <LoanApplicationCommentsList />
                </Card>
                <Pagination store={store as unknown as BasicStore<Entity>} />
            </>
        );
    },
);

const StyledCardTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;
